import type { ReactNode } from 'react';
import { cn } from './utils';

export type BadgeTone =
  | 'neutral'
  | 'brand'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'outline';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-neutral-subtle text-neutral-content border-transparent',
  brand: 'bg-brand-subtle text-brand border-transparent',
  success: 'bg-success-subtle text-success-content border-transparent',
  warning: 'bg-warning-subtle text-warning-content border-transparent',
  danger: 'bg-danger-subtle text-danger-content border-transparent',
  info: 'bg-info-subtle text-info-content border-transparent',
  outline: 'bg-transparent text-content-muted border-border',
};

export interface BadgeProps {
  readonly children: ReactNode;
  readonly tone?: BadgeTone;
  readonly size?: 'sm' | 'md';
  readonly icon?: ReactNode;
  readonly className?: string;
  /**
   * Texto adicional só para leitor de tela. Usado quando o badge é a única
   * pista visual de um estado (WCAG 1.4.1) — ex.: "Situação: Aprovado".
   */
  readonly srPrefix?: string;
}

export function Badge({
  children,
  tone = 'neutral',
  size = 'md',
  icon,
  className,
  srPrefix,
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border font-medium',
        size === 'sm' ? 'px-1.5 py-px text-2xs' : 'px-2 py-0.5 text-xs',
        TONES[tone],
        className,
      )}
    >
      {srPrefix ? <span className="qc-sr-only">{srPrefix} </span> : null}
      {icon}
      <span>{children}</span>
    </span>
  );
}
